window.PNProductAddons = (() => {

  function getSelectedServices() {
    return Array.from(
      document.querySelectorAll('.pn-addon__checkbox:checked')
    ).map((checkbox) => ({
      id: Number(checkbox.value),
      name: checkbox.dataset.serviceName,
      price: Number(checkbox.dataset.price || 0),
      checkboxEl: checkbox
    }));
  }

  // Returns null if no add-ons are selected (caller should fall back to the
  // normal single-item FormData request). Otherwise returns a JSON string
  // body ready to POST to /cart/add.js with Content-Type: application/json.
  function buildRequest(formData, extra) {
    const services = getSelectedServices();

    if (services.length === 0) {
      return null;
    }

    const quantity = Number(formData.get('quantity') || 1);
    const mainVariant = Number(formData.get('id'));

    const addonsContainer = document.querySelector('.pn-product-addons');
    const productTitle = addonsContainer
      ? addonsContainer.dataset.productTitle
      : '';
    // For multi-colour sarees, say which colour the add-on is for (shows on the order)
    let variantTitle = '';
    try {
      const sel = document.querySelector('variant-selects [data-selected-variant]');
      const v = sel ? JSON.parse(sel.textContent) : null;
      if (v && Number(v.id) === mainVariant && v.title && v.title !== 'Default Title') variantTitle = v.title;
    } catch (e) {}
    const addedFor = variantTitle ? `${productTitle} (${variantTitle})` : productTitle;  

    const items = [
      {
        id: mainVariant,
        quantity,
        properties: {
          '_addons': services.map((service) => service.name).join(', ')
        }
      }
    ];

    services.forEach((service) => {
      items.push({
        id: service.id,
        quantity,
        properties: {
          // Visible in cart drawer / cart page / order summary (Dawn hides
          // any property whose key starts with "_").
          'Added for': addedFor,
          '_parent_variant': String(mainVariant)
        }
      });
    });

    const payload = Object.assign({ items }, extra || {});

    return JSON.stringify(payload);
  }

  // Uncheck all add-on checkboxes, e.g. after a successful add-to-cart.
  function reset() {
    document
      .querySelectorAll('.pn-addon__checkbox:checked')
      .forEach((checkbox) => {
        checkbox.checked = false;
      });
    updateAddToCartButtonText();
  }

  // Lightweight reimplementation of Shopify's money.js formatMoney, driven
  // by window.pnMoneyFormat (the shop's money_format setting). Self
  // contained so this doesn't depend on any third-party app's helper.
  function formatMoney(cents, format) {
    const defaultFormat = '${{amount}}';
    format = format || window.pnMoneyFormat || defaultFormat;

    function addCommas(value, precision, thousands, decimal) {
      precision = typeof precision === 'undefined' ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(value) || value === null) return '0';

      const fixed = (Number(value) / 100).toFixed(precision);
      const parts = fixed.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }

    const placeholderMatch = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!placeholderMatch) return String(cents);

    let value = '';
    switch (placeholderMatch[1]) {
      case 'amount':
        value = addCommas(cents, 2);
        break;
      case 'amount_no_decimals':
        value = addCommas(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = addCommas(cents, 2, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = addCommas(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = addCommas(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = addCommas(cents, 0, ' ');
        break;
      default:
        value = addCommas(cents, 2);
    }

    return format.replace(placeholderMatch[0], value);
  }

  // Recalculates (product price + selected add-ons) × quantity, and updates
  // the Add to Cart button text accordingly. Leaves the button untouched
  // when it's disabled (sold out / unavailable) so we never override that
  // messaging.
  function updateAddToCartButtonText() {
    const submitButton = document.querySelector('.product-form__submit');
    if (!submitButton || submitButton.hasAttribute('disabled')) return;

    const submitButtonText = submitButton.querySelector('span');
    if (!submitButtonText) return;

    const addonsContainer = document.querySelector('.pn-product-addons');
    const unitPrice = addonsContainer ? Number(addonsContainer.dataset.unitPrice || 0) : 0;
    const services = getSelectedServices();

    const defaultText =
      (window.variantStrings && window.variantStrings.addToCart) || submitButtonText.textContent;

    if (services.length === 0) {
      submitButtonText.textContent = defaultText;
      return;
    }

    // Scoped to this product's own <product-info> section, not the whole
    // page — a global querySelector('.quantity__input') can accidentally
    // grab a DIFFERENT quantity input belonging to an existing cart-drawer
    // line item (the cart drawer is present in the DOM on every page),
    // silently multiplying the displayed total by the wrong quantity.
    const productScope = addonsContainer ? addonsContainer.closest('product-info') : null;
    const quantityInput = productScope
      ? productScope.querySelector('.quantity__input')
      : document.querySelector('.quantity__input');
    const quantity = quantityInput ? Number(quantityInput.value || 1) : 1;

    const addonsTotal = services.reduce((sum, service) => sum + service.price, 0);
    const total = (unitPrice + addonsTotal) * quantity;

    submitButtonText.textContent = `${defaultText} • ${formatMoney(total)}`;
  }

  document.addEventListener('change', (event) => {
    if (event.target.matches('.pn-addon__checkbox, .quantity__input')) {
      updateAddToCartButtonText();
    }
  });
  document.addEventListener('input', (event) => {
    if (event.target.matches('.quantity__input')) {
      updateAddToCartButtonText();
    }
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const addonsContainer = document.querySelector('.pn-product-addons');
      const variant = event && event.data && event.data.variant;
      if (addonsContainer && variant && typeof variant.price !== 'undefined') {
        addonsContainer.dataset.unitPrice = variant.price;
      }
      updateAddToCartButtonText();
    });
  }

  return {
    getSelectedServices,
    buildRequest,
    reset,
    updateAddToCartButtonText
  };

})();